export const vms_gen52 = [
  { name: "VM01 Zerschneider", location: "Eventura City – Schule nach Arenasieg" },
  { name: "VM02 Fliegen", location: "Twist Mountain – nach Arenasieg von Marlon" },
  { name: "VM03 Surfer", location: "Route 6 – von Cheren" },
  { name: "VM04 Stärke", location: "Pokéwood – NPC gibt sie" },
  { name: "VM05 Blitz", location: "Stratos City – Pokémon Center NPC" },
  { name: "VM06 Taucher", location: "Undella Town – nach Arenasieg" },
  { name: "VM07 Kaskade", location: "Route 23 – bei einem NPC" },
  { name: "VM08 Zertrümmerer", location: "Wendelberg – Nebenraum" }
];